import React, {useCallback, useState} from "react";
import i18n from "../../../../locale/i18n";
import RestClientInstance from "../../../../lib/RestClient";
import {Button, Form, Grid, Input} from "semantic-ui-react";

interface MailBoxAuthLoginProps {

  onAuthenticated(token: string): void;
  onClickReset(): void;
}
const t = i18n.t.bind(i18n);

function MailBoxAuthLogin(props: MailBoxAuthLoginProps) {
  const { onAuthenticated, onClickReset } = props;

  const [loginPinInput, setLoginPinInput] = useState<string>('');
  const [authenticating, setAuthenticating] = useState<boolean>(false);
  const [loginError, setLoginError] = useState('');
  const loginFormInvalid = loginPinInput.length === 0;
  const authenticate = useCallback(() => {
    if(authenticating) {
      return;
    }
    if(loginPinInput.length === 0) {
      return;
    }
    setLoginError('');
    setAuthenticating(true);
    RestClientInstance.post('mailbox/auth/login', {
        pin: loginPinInput
      })
      .then(response => {
        if(response.data.success) {
          onAuthenticated(response.data.token);
        } else {
          setAuthenticating(false);
          setLoginPinInput('');
          let errorMessage = 'Error: ' + response.data.message;
          switch(response.data.message) {
            case 'too_many_tries':
              errorMessage = t('MailBox.Auth.Login.Error.TooManyTries');
              break;
            case 'invalid_pin':
              errorMessage = t('MailBox.Auth.Login.Error.InvalidPin');
              if(response.data.triesRemaining) {
                errorMessage += ' ' + t('MailBox.Auth.Login.Error.InvalidPinRemainingTries', { triesRemaining: response.data.triesRemaining });
              }
              break;
            case 'pin_not_set':
              errorMessage = t('MailBox.Auth.Login.Error.PinNotSet');
              break;
            default:
          }

          setLoginError(errorMessage);
        }
      }).catch(error => {
      setAuthenticating(false);
    });
  }, [authenticating, loginPinInput, onAuthenticated, setLoginError]);

  return <div>
    <p>{t('MailBox.Auth.Login.LoginParagraph1')}</p>
    <Grid>
      <Grid.Row>
        <Grid.Column mobile="16" computer="6">
          <Form onSubmit={authenticate}>
            <Form.Field>
              <label>{t('MailBox.Auth.Login.InputPINLabel')}</label>
              <Input type="password"
                     pattern="[0-9]{6}"
                     minLength={6}
                     maxLength={6}
                     inputMode="numeric"
                     name="pin_input"
                     autoComplete="one-time-code"
                     disabled={authenticating}
                     value={loginPinInput}
                     onChange={(ev,data) => setLoginPinInput(data.value)}
                     icon="lock" />
            </Form.Field>

            <p className="" style={{color: '#89220a'}}>
              {loginError || <>&nbsp;</>}
            </p>
            <Form.Button type="submit"
                         loading={authenticating}
                         disabled={loginFormInvalid}
                         primary>
              {t('MailBox.Auth.Login.ButtonLogin')}
            </Form.Button>
            <Button type="button" disabled={authenticating} basic
                    className="link" onClick={onClickReset}>
              {t('MailBox.Auth.Login.ButtonResetPIN')}
            </Button>
          </Form>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>;
}

export default MailBoxAuthLogin;